






















































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class FormInstruksiSection extends Vue {
  @Prop() form!: any;
  @Prop({ default: false }) formValid!: boolean;
  @Prop({ default: false }) saving!: boolean;
  @Prop({ default: false }) isEdit!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = false;

  get hasInstruksi() {
    return this.form.instruksi_no_rjp || this.form.instruksi_tanpa_intubasi || this.form.instruksi_suportif;
  }

  get instruksiError() {
    return !this.hasInstruksi
      && (this.form.alasan_dnr || this.form.dasar_keputusan);
  }
}
